import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import { ChannelLineup } from '@leshen/ui'

const ChannelLineupWithData = ({ brandyToken = '' }) => {
  const data = useStaticQuery(graphql`
    query brandyPackageChannelQuery {
      packages: allBrandyPackage(filter: { comparison: { eq: true } }) {
        edges {
          node {
            name
            brandy_id
            brand_token
          }
        }
      }
      channels: allBrandyChannels {
        edges {
          node {
            brandy_id
            brand_token
            id
            name
            packageAvailability
          }
        }
      }
    }
  `)
  const channelData = {
    packages: {
      edges: (data?.packages?.edges || []).filter(
        (current) => current?.node?.brand_token === brandyToken
      ),
    },
    channels: {
      edges: (data?.channels?.edges || []).filter(
        (current) => current?.node?.brand_token === brandyToken
      ),
    },
  }
  if (!channelData.channels.edges.length) {
    console.warn(
      `null data: Check Channel Line up Data and Brandy Token exist: ${brandyToken}`
    )
  }
  return <ChannelLineup data={channelData} />
}

export default ChannelLineupWithData
